import { UIMessage } from "ai";
import { getMessageText } from "@/features/workstation/utils/message-utils";

export const shouldShowChatLoading = (messages: UIMessage[], isLoading: boolean): boolean => {
  if (!isLoading) return false;

  const userMessageIndexes = messages
    .map((msg, index) => msg.role === 'user' ? index : -1)
    .filter(index => index !== -1);

  const lastUserMessageIndex = userMessageIndexes.length > 0 
    ? userMessageIndexes[userMessageIndexes.length - 1] 
    : -1;

  if (lastUserMessageIndex === -1) return true;

  const lastUserMessage = messages[lastUserMessageIndex];
  const hasContent = getMessageText(lastUserMessage).trim().length > 0;

  if (!hasContent) return false;

  const hasValidAssistantResponse = messages.some((msg, index) => {
    if (msg.role !== 'assistant' || index <= lastUserMessageIndex) {
      return false;
    }
    const content = getMessageText(msg).trim();
    return content.length > 0;
  });

  return !hasValidAssistantResponse;
};
 
